export type NumberingScope = 'annual' | 'monthly';
export type NumberingType = 'numeric' | 'alphanumeric';

export interface NumberingConfig {
  scope: NumberingScope; // annual or monthly
  type: NumberingType;  // numeric or alphanumeric
  prefix?: string;      // used for alphanumeric, e.g., ENT-
  pad?: number;         // zero pad, default 5
}

const SETTINGS_KEY = 'comptaEBNL_entite_settings';
const COUNTERS_KEY = 'comptaEBNL_ecritures_counters';

export interface EntiteSettings {
  entityName: string;
  numbering: NumberingConfig;
  autoGenerateFiche: boolean;
}

export function loadEntiteSettings(): EntiteSettings {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return {
    entityName: 'Entité EBNL',
    numbering: { scope: 'annual', type: 'numeric', prefix: 'ENT-', pad: 5 },
    autoGenerateFiche: true,
  };
}

export function saveEntiteSettings(s: EntiteSettings) {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(s));
}

function loadCounters(): Record<string, number> {
  try {
    return JSON.parse(localStorage.getItem(COUNTERS_KEY) || '{}');
  } catch {
    return {};
  }
}

function saveCounters(c: Record<string, number>) {
  localStorage.setItem(COUNTERS_KEY, JSON.stringify(c));
}

export function generateNextReference(dateISO: string, cfg?: NumberingConfig): string {
  const config = cfg || loadEntiteSettings().numbering;
  const d = dateISO || new Date().toISOString().slice(0,10);
  const year = d.slice(0,4);
  const month = d.slice(0,7);
  const key = config.scope === 'annual' ? year : month;
  const counters = loadCounters();
  const current = counters[key] || 0;
  const next = current + 1;
  counters[key] = next;
  saveCounters(counters);
  const pad = config.pad ?? 5;
  const base = String(next).padStart(pad, '0');
  if (config.type === 'alphanumeric') {
    const prefix = config.prefix || '';
    return `${prefix}${key.replace('-', '')}-${base}`;
  }
  return `${key.replace('-', '')}-${base}`;
}